import { date } from "quasar";

const urlNegociacaoAtivos = window.location.origin + "/api/negociacao_ativos/";

const urlMovimentacaoTesouro =
	window.location.origin + "/api/movimentacao_tesouro/";

const urlOpcoesTesouroDireto =
	window.location.origin + "/api/tesouro_direto/?ticker_symbol=IPCA";

export default {
	data() {
		return {
			baseURL: window.location.origin,
			objetivos_api: {},
			campos_objetivo: {
				pr_renda_fixa: "",
				pr_renda_variavel: "",
				pr_renda_variavel_eua: "",
				pr_renda_variavel_br: "",
			},
			objetivos: {
				acoes: [],
				fiis: [],
				stocks: [],
				reits: [],
				titulos: [],
			},
			tipo_atual: "",
			product_type_name: "",

			step: {
				id: 1,
				tipo: "",
			},
			modalActive: "",
			nome_correto: "",
			loading: false,
			errorSteps: [],
			modal1: null,
			modalAviso: null,
			modalNovoAporte: null,
			status_campos: {
				no_has_renda_variavel: false,
				no_has_br: false,
				no_has_acoes: false,
				no_has_fiis: false,
				no_has_eua: false,
				no_has_reits: false,
				no_has_stocks: false,
			},

			origin_click: "",
			quantidadeItens: 3,
			verMaisIsOpen: false,
			tipo_atual: "",
			tiposInvestimento: {
				acoes: [],
				fiis: [],
				stocks: [],
				reits: [],
				tesouroDireto: [],
			},
			naoMostrarNovamente: false,
			disponivelAportar: "0,00",
			disponivelAportarTotal: "0,00",
			hasAtivosListLoaded: false,
			idOndeAportar: null,
			ativosList: [],
			qtAtivosOptions: [
				{
					label: "1",
					value: 1,
				},
				{
					label: "2",
					value: 2,
				},
				{
					label: "3",
					value: 3,
				},
			],
			qtAtivosAportar: {
				label: "1",
				value: 1,
			},
			isLoading: false,
			formModalAtivo: {
				ticker_symbol: "",
				side: "Compra",
				reference_date: "",
				trade_quantity: "",
				gross_amount: "",
				product_type_name: "",

				// ticker_symbol: WEGE3
				// side: Compra
				// reference_date: 2024-08-01
				// trade_quantity: 10
				// gross_amount: 500
				// product_type_name: Ações
			},
			corretagem: "",
			tipoAtivoOptions: [
				{ label: "Ações", value: "Ações", id: 1 },
				{
					label: "FIIs",
					value: "FII - Fundo de Investimento Imobiliário",
					id: 2,
				},
				{ label: "Stocks", value: "Stock", id: 3 },
				{ label: "REIT", value: "REIT", id: 4 },
				{ label: "Renda fixa", value: "TesouroDireto", id: 5 },
			],
			ativoOptions: [],
			hasValueInSearch: false,
			inputIsInvalid: false,
			selectsHasFilled: false,
		};
	},

	async mounted() {
		await this.setValuesOndeAportar();
		await this.getAtivosOndeAportar();
	},

	computed: {
		toggleVerMais() {
			return this.quantidadeItens == 3 ? "Ver mais" : "Ver menos";
		},
		minDate() {
			const currentDate = new Date();
			const minYear = currentDate.getFullYear() - 5;
			let min = new Date(currentDate);

			// Se o dia atual for sábado (6) ou domingo (0), ajuste minDate para o próximo dia útil (segunda-feira)
			if (min.getDay() === 6) {
				min.setDate(min.getDate() + 2);
			} else if (min.getDay() === 0) {
				min.setDate(min.getDate() + 1);
			}
			// } else {
			// 	min = new Date(minYear, min.getMonth(), min.getDate());
			// }
			const isStockOrREIT =
				this.formModalAtivo.product_type_name === "Stock" ||
				this.formModalAtivo.product_type_name === "REIT" ||
				(this.formModalAtivo.product_type_name &&
					this.formModalAtivo.product_type_name.value === "Stock") ||
				(this.formModalAtivo.product_type_name &&
					this.formModalAtivo.product_type_name.value === "REIT");
			// console.log(`${minYear}-${min.getMonth() + 1}-${min.getDate() + 1}`)
			// if (isStockOrREIT) {
			// 	const dateCorrect = `${min.getDay()}/${
			// 		min.getMonth() + 1
			// 	}/${min.getFullYear()}`;
			// 	return dateCorrect;
			// }
			return "";
		},
	},

	methods: {
		/** Normaliza resposta do GET /api/onde_aportar/ (array direto, paginado ou { data: [] }) */
		normalizarListaOndeAportar(data) {
			if (!data) return [];
			if (Array.isArray(data)) return data;
			return data.results ?? data.data ?? [];
		},

		changeToMonetarioBrl(valor) {
			if (!valor) return null;
			return valor.toLocaleString("pt-BR", { minimumFractionDigits: 2 });
		},

		changeToFloatApi(valor) {
			if (!valor) return null;
			return valor.replaceAll(".", "").replace(",", ".");
		},

		async setValuesOndeAportar() {
			this.modal1 = ModalX(".modal-edicao-objetivo", {
				deep: true,
				zIndex: 300000,
				zIndexDeep: 20000,
				bgModal: "rgb(30,33,36)",
				closeOnDeep: false,
			});

			this.modalAviso = ModalX(".modal-aviso", {
				deep: true,
				zIndex: 300000,
				zIndexDeep: 20000,
				closeOnDeep: true,
				bgModal: "rgb(30,33,36)",
			}).init();

			this.modalNovoAporte = ModalX(".modal-novo-ativo", {
				deep: true,
				zIndex: 300000,
				zIndexDeep: 20000,
				closeOnDeep: false,
				bgModal: "rgb(30,33,36)",
			}).init();

			this.naoMostrarNovamente =
				GLOBAL.getCookie("naoMostrarNovamente") == "true" ? true : false;

			const cardItem = document.querySelector(`.step-${this.step.id}`);
			this.modalActive = this.modal1;
			this.modalActive.init();
			await this.getDataFromObjective();
			await this.getObjetivos();
			await this.verifyIfReceivedValuesIsNull();
			// await this.persistErrorIfHasInvalidModal(modal1)
			axios
				.get(`${this.baseURL}/api/ativos_variaveis/?onde_aportar=1`)
				.then(({ data }) => {
					console.log(data, "data");
					this.tiposInvestimento.acoes = data
						.filter((i) => i.product_type_name === "Ações")
						.sort(
							({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a,
						);
					this.tiposInvestimento.fiis = data
						.filter(
							(i) =>
								i.product_type_name ===
								"FII - Fundo de Investimento Imobiliário",
						)
						.sort(
							({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a,
						);
					this.tiposInvestimento.stocks = data
						.filter((i) => i.product_type_name === "Stock")
						.sort(
							({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a,
						);
					this.tiposInvestimento.reits = data
						.filter((i) => i.product_type_name === "REIT")
						.sort(
							({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a,
						);
				})
				.catch((error) => {
					GLOBAL.showToastify(error);
					console.error(error);
				});

			axios
				.get(`${this.baseURL}/api/titulos_tesouro/?onde_aportar=1`)
				.then(({ data }) => {
					this.tiposInvestimento.tesouroDireto = data
						.filter((i) => i.product_type_name === "TesouroDireto")
						.sort(
							({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a,
						);
				})
				.catch((error) => {
					GLOBAL.showToastify(error);
					console.error(error);
				});
			if (this.naoMostrarNovamente) return;
			this.modalAviso.openModal(1);
			console.log(GLOBAL);
		},

		async setDisponivelAportar(ev, varName) {
			this[varName] = ev.target.value;
			// Usar idOndeAportar (registro já existe no backend) para decidir PATCH vs POST
			this.idOndeAportar
				? await this.patchAtivosOndeAportar()
				: await this.postAtivosOndeAportar();
		},

		async setQtAtivosAportar(ev, varName) {
			this[varName] = ev;
			// Usar idOndeAportar (registro já existe no backend) para decidir PATCH vs POST
			this.idOndeAportar
				? await this.patchAtivosOndeAportar()
				: await this.postAtivosOndeAportar();
		},

		async getAtivosOndeAportar() {
			try {
				const { data } = await axios.get(`${this.baseURL}/api/onde_aportar/`);
				const list = this.normalizarListaOndeAportar(data);
				if (list.length > 0) {
					const first = list[0];
					this.idOndeAportar = first.id;
					this.disponivelAportar = this.returnMonetaryValue(
						parseFloat(first.valor),
					);
					this.qtAtivosAportar =
						this.qtAtivosOptions.filter(
							(v) => v.value === first.num_ativos,
						)[0] || this.qtAtivosAportar;
					if (first.indicacao) {
						this.ativosList = first.indicacao.indicacoes || [];
						this.disponivelAportarTotal = this.returnMonetaryValue(
							first.indicacao.valor_total,
						);
					} else {
						this.ativosList = [];
					}
				}
				this.hasAtivosListLoaded = true;
			} catch (error) {
				console.log(error);
			}
		},

		async patchAtivosOndeAportar() {
			const disponivelAportarFloat = parseFloat(
				this.changeToFloatApi(this.disponivelAportar),
			);
			// const { data } = await axios.get(`${this.baseURL}/api/objetivo/onde_aportar/?quantidade=${this.qtAtivosAportar.value}&valor=${disponivelAportarFloat}`)

			const payloadPostAportar = {
				num_ativos: this.qtAtivosAportar.value,
				valor: disponivelAportarFloat,
			};

			try {
				const { data } = await axios.patch(
					`${this.baseURL}/api/onde_aportar/${this.idOndeAportar}/`,
					payloadPostAportar,
				);

				console.log(data);
				await this.getAtivosOndeAportar();
			} catch (error) {
				Object.entries(error.response.data).map(([key, value]) => {
					GLOBAL.showToastify(`${key}: ${value}`, "#DE4B4F");
					throw new Error(`${key}: ${value}`);
				});
				throw new Error(error.response.data);
			}
		},

		async postAtivosOndeAportar() {
			const payloadPostAportar = {
				num_ativos: this.qtAtivosAportar.value,
				valor: parseFloat(this.changeToFloatApi(this.disponivelAportar)),
			};

			try {
				// Sempre conferir no backend se já existe registro (evita POST quando já existe instância)
				const { data: listData } = await axios.get(
					`${this.baseURL}/api/onde_aportar/`,
				);
				const list = this.normalizarListaOndeAportar(listData);
				const existingId = list.length > 0 ? list[0].id : null;
				if (existingId != null && existingId !== "") {
					this.idOndeAportar = existingId;
					await this.patchAtivosOndeAportar();
					return;
				}

				await axios.post(
					`${this.baseURL}/api/onde_aportar/`,
					payloadPostAportar,
				);
				await this.getAtivosOndeAportar();
			} catch (error) {
				// Fallback: backend disse que já existe registro → buscar id e fazer PATCH
				const msg = error.response?.data?.objetivo;
				const jaPossuiRegistro = Array.isArray(msg)
					? msg.some((m) =>
							String(m).includes("já possui um registro de onde aportar"),
						)
					: String(msg || "").includes("já possui um registro de onde aportar");
				if (jaPossuiRegistro) {
					try {
						const { data: listData } = await axios.get(
							`${this.baseURL}/api/onde_aportar/`,
						);
						const list = this.normalizarListaOndeAportar(listData);
						const existingId = list.length > 0 ? list[0].id : null;
						if (existingId != null && existingId !== "") {
							this.idOndeAportar = existingId;
							await this.patchAtivosOndeAportar();
							return;
						}
					} catch (e) {
						console.log(e);
					}
				}
				console.log(error);
			}
		},

		returnMonetaryValue(value) {
			if (!value) return null;
			return GLOBAL.FormatREALVirgula(value);
		},

		setPatternInputValue(value) {
			return value == null || isNaN(value) ? 0 : Number(value);
		},

		async getDataFromObjective() {
			this.loading = true;
			await axios
				.get(`${this.baseURL}/api/objetivo/`)
				.then(({ data }) => {
					this.objetivos_api = data;
					this.campos_objetivo.pr_renda_fixa = Number(
						this.setPatternInputValue(this.objetivos_api[0]?.pr_renda_fixa),
					);
					this.campos_objetivo.pr_renda_variavel = Number(
						this.setPatternInputValue(this.objetivos_api[0]?.pr_renda_variavel),
					);
					this.campos_objetivo.pr_renda_variavel_br = Number(
						this.setPatternInputValue(
							this.objetivos_api[0]?.pr_renda_variavel_br,
						).toFixed(2),
					);
					this.campos_objetivo.pr_renda_variavel_eua = Number(
						this.setPatternInputValue(
							this.objetivos_api[0]?.pr_renda_variavel_eua,
						).toFixed(2),
					);
					this.campos_objetivo.pr_acoes = Number(
						this.setPatternInputValue(this.objetivos_api[0]?.pr_acoes).toFixed(
							2,
						),
					);
					this.campos_objetivo.pr_fiis = Number(
						this.setPatternInputValue(this.objetivos_api[0]?.pr_fiis).toFixed(
							2,
						),
					);
					this.campos_objetivo.pr_stocks = Number(
						this.setPatternInputValue(this.objetivos_api[0]?.pr_stocks).toFixed(
							2,
						),
					);
					this.campos_objetivo.pr_reits = Number(
						this.setPatternInputValue(this.objetivos_api[0]?.pr_reits).toFixed(
							2,
						),
					);
				})
				.catch((error) => {
					GLOBAL.showToastify(error, "#DE4B4F");
					console.error(error);
				})
				.finally(() => {
					this.loading = false;
				});
		},

		/* Funções de controle dos steps do wizard*/
		verifyStepAndSetThePatterns(current, tipo = "default") {
			if (this.step.id == current) {
				this.step.tipo = tipo;
				this.tipo_atual = tipo;
			}
		},

		defineTypeProduct(variable) {
			switch (variable) {
				case "acoes":
					this.product_type_name = "Ações";
					break;
				case "fiis":
					this.product_type_name = "FII - Fundo de Investimento Imobiliário";
					break;
				case "stocks":
					this.product_type_name = "Stock";
					break;
				case "reits":
					this.product_type_name = "REIT";
					break;
				case "titulos":
					this.product_type_name = "TesouroDireto";
					break;
			}
		},

		setOriginClick(tipo) {
			if (tipo == "eua") {
				this.origin_click = "eua";
			} else if (tipo == "br") {
				this.origin_click = "br";
			} else if (tipo == "stocks") {
				this.origin_click = "stocks";
			} else if (tipo == "reits") {
				this.origin_click = "reits";
			} else if (tipo == "acoes") {
				this.origin_click = "acoes";
			} else if (tipo == "fiis") {
				this.origin_click = "fiis";
			}
		},

		async verifyIfReceivedValuesIsNull() {
			if (this.campos_objetivo.pr_renda_variavel_br === 0) {
				this.status_campos.no_has_acoes = true;
				this.status_campos.no_has_fiis = true;
			}

			if (this.campos_objetivo.pr_renda_variavel_eua === 0) {
				this.status_campos.no_has_reits = true;
				this.status_campos.no_has_stocks = true;
			}

			if (this.campos_objetivo.pr_renda_variavel == 0) {
				this.status_campos.no_has_eua = true;
				this.status_campos.no_has_br = true;
				this.status_campos.no_has_acoes = true;
				this.status_campos.no_has_fiis = true;
				this.status_campos.no_has_stocks = true;
				this.status_campos.no_has_reits = true;
			}
		},

		updateValueStep(id, tipo = "vazio") {
			this.isPercentFull = false;
			this.isValid = false;
			this.showError = false;
			this.modalValueIsValid = false;
			this.getDataFromObjective();
			this.setOriginClick(tipo);
			this.step = { id, tipo };
			if (tipo == "eua" || tipo == "br") return;
			this.defineTypeProduct(this.step.tipo);
			this.verifyStepAndSetThePatterns(id, tipo);
		},

		hasErrorOnInit() {
			Object.entries(this.objetivos).map(([key, value]) => {
				const calculo = value.reduce(
					(acc, i) => (acc = acc + Number(i.porcentagem_desejada)),
					0,
				);
				if (calculo < 100) {
					this.errorSteps.push({ [key]: value });
					this.modal1.openModal(5, key);
					this.updateValueStep(5, key);
					return value;
				}
				return;
			});
		},

		async getObjetivos(tipo) {
			const entries = Object.entries(this.objetivos).map(([key, value]) => key);

			const dadosCall = entries.map((key) => {
				return axios.get(`${this.baseURL}/api/item_objetivo_${key}/`);
			});
			Promise.all(dadosCall)
				.then((response) => {
					response.forEach(({ data }, index) => {
						const objetivosAtuais = data;
						const objetivoModificado = objetivosAtuais.map((i, idx) => {
							let secoes_ativos = [
								"pr_acoes",
								"pr_fiis",
								"pr_stocks",
								"pr_reits",
								"pr_renda_fixa",
							];
							const teste2 = this.objetivos_api[0]?.pr_acoes;
							const teste3 = Number(i.porcentagem_desejada);
							i.porcentagem_desejada = Number(i.porcentagem_desejada).toFixed(
								2,
							);
							return i;
						});

						this.objetivos[entries[index]] = [...objetivoModificado];
					});
				})
				.catch((error) => {
					GLOBAL.showToastify(error, "#DE4B4F");
					console.error(error);
				});
		},

		updateNome(nome) {
			this.nome_correto = nome;
		},

		openModalAction(value, tipo) {
			this.modalActive.openModal(value);
			if (
				this.step.id == 1 &&
				this.tipo_atual == "titulos_inicio" &&
				this.campos_objetivo.pr_renda_fixa
			) {
				this.updateValueStep(5, "titulos");
				this.nome_correto = "Tesouro direto";
				this.product_type_name = "TesouroDireto";
			}
			// else if (this.step.id == 4 && this.tipo_atual == 'eua') {
			//   this.updateValueStep(5, 'reits')
			// }
			// else if (this.step.id == 3 && this.tipo_atual == 'br') {
			//   this.updateValueStep(5, 'acoes')
			// }
		},

		outsideClick({ target }) {
			if (target.closest(".btn-vermais")) return;
			this.quantidadeItens = 3;
		},

		handleToggle(tipo) {
			const isThree =
				this.quantidadeItens == 3
					? (this.quantidadeItens = this.tiposInvestimento[tipo].length)
					: (this.quantidadeItens = 3);
			console.log(isThree);
			return isThree;
		},

		submitModalAviso() {
			if (this.naoMostrarNovamente) {
				GLOBAL.setCookie("naoMostrarNovamente", true, 7);
			} else {
				GLOBAL.setCookie("naoMostrarNovamente", false, 7);
			}
			this.modalAviso.closeModal();
		},

		//////////////////////////////////////////////////////////////////////////////////////////

		format(date) {
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();

			return `${day}/${month}/${year}`;
		},

		disableDates(date) {
			const today = new Date();
			const dayOfWeek = date.getDay(); // obter o dia da semana da data
			return date > today || dayOfWeek === 0 || dayOfWeek === 6; // desabilitar datas maiores que hoje ou em fins de semana
		},

		validateModalFields({ target }) {
			const isNullish = Object.entries(this.formModalAtivo).some(
				([key, value]) => {
					if (key == "corretagem") return;
					if (!value) {
						return true;
					}
					return false;
				},
			);

			this.modalValueIsValid = Boolean(!isNullish);
		},

		async openModalNovoAporte(selectedAtivo, id) {
			try {
				this.formModalAtivo.product_type_name = this.tipoAtivoOptions.filter(
					(v) => v.value === selectedAtivo.product_type_name,
				)[0];

				if (selectedAtivo.product_type_name !== "TesouroDireto") {
					this.ativoOptions = [
						{
							value: selectedAtivo.ticker_symbol,
							label: selectedAtivo.ticker_symbol,
							id,
						},
					];

					this.formModalAtivo.ticker_symbol = {
						value: selectedAtivo.ticker_symbol,
						label: selectedAtivo.ticker_symbol,
						id,
					};
				} else {
					const { data } = await axios.get(urlOpcoesTesouroDireto);

					this.ativoOptions = data.map(({ ticker_symbol }) => {
						return {
							value: ticker_symbol,
							label: ticker_symbol,
						};
					});
				}

				this.hasValueInSearch = true;
				this.selectsHasFilled = true;
				this.applyMonetaryMask();
				setTimeout(() => {
					this.modalNovoAporte.openModal(2);
				}, 500);
			} catch (error) {
				GLOBAL.showToastify(error);
				console.error(error);
			}
		},

		validateValueInputPrice(event, payloadName) {
			this.formModalAtivo[payloadName] = event.target.value;
		},

		changeVirgulaToComma(value) {
			return value.replace(",", ".");
		},

		validateValueInputQuantity(event) {
			const inputValue = event.target.value;
			let numerosValidos = false;
			const removerCaracteres = (string, regexValue) =>
				string.replace(regexValue, "");
			numerosValidos = /^[0-9]+$/.test(inputValue);
			if (!numerosValidos) {
				event.target.value = removerCaracteres(inputValue, /[^0-9]/g);
				this.validateValueInputPrice(event, "trade_quantity");
			}
		},

		validateInput() {
			this.erros = [];

			if (!this.formModalAtivo.trade_quantity) {
				this.erros.push("Informe a quantidade!");
			}
			if (
				parseFloat(
					this.changeToFloatApi(this.formModalAtivo.trade_quantity),
				) === 0
			) {
				this.erros.push("A quantidade deve ser maior que zero!");
			}
			if (!this.formModalAtivo.reference_date) {
				this.erros.push("Informe a data de compra!");
			}
			if (!this.formModalAtivo.gross_amount) {
				this.erros.push("Informe o preço de venda!");
			}
			if (
				parseFloat(this.changeToFloatApi(this.formModalAtivo.gross_amount)) ===
				0
			) {
				this.erros.push("O preço de venda deve ser maior que zero!");
			}
			if (!this.formModalAtivo.ticker_symbol) {
				this.erros.push("Informe o ativo!");
			}
		},

		showToastifyOnErrorInputs() {
			if (this.erros.length) {
				this.modalValueIsValid = false;
				this.erros.forEach((i) => {
					GLOBAL.showToastify(i, "#DE4B4F");
					return;
				});
			}
		},

		async onSubmitModalNovoAporte({ currentTarget }) {
			this.erros = [];

			this.validateInput();
			this.showToastifyOnErrorInputs();

			// this.formModalAtivo.gross_amount = this.changeVirgulaToComma(this.formModalAtivo.gross_amount);
			// this.formModalAtivo.trade_quantity = this.changeVirgulaToComma(this.formModalAtivo.trade_quantity);
			//this.formModalAtivo.reference_date = await this.formatDateMovimentacao(this.formModalAtivo.reference_date);

			if (!this.erros.length) {
				this.formModalAtivo.product_type_name.value === "TesouroDireto"
					? await this.postMovimentacaoTesouro(currentTarget)
					: await this.postNegociacaoAtivos(currentTarget);
			}
		},

		async postNegociacaoAtivos(currentTarget) {
			try {
				const payloadNegociacaoAtivos = { ...this.formModalAtivo };

				const form = currentTarget.closest("form");

				this.formModalAtivo.product_type_name =
					this.formModalAtivo.product_type_name.value ||
					this.formModalAtivo.product_type_name;
				const productType = document.createElement("input");
				productType.type = "hidden";
				productType.name = "product_type_name";
				productType.value = this.formModalAtivo.product_type_name;

				form.appendChild(productType);

				this.isLoading = true;
				// form.submit();

				payloadNegociacaoAtivos.ticker_symbol =
					typeof payloadNegociacaoAtivos.ticker_symbol === "object" &&
					payloadNegociacaoAtivos.ticker_symbol !== null
						? payloadNegociacaoAtivos.ticker_symbol.value
						: payloadNegociacaoAtivos.ticker_symbol;

				payloadNegociacaoAtivos.product_type_name =
					payloadNegociacaoAtivos.product_type_name.value;

				payloadNegociacaoAtivos.reference_date = date.formatDate(
					payloadNegociacaoAtivos.reference_date,
					"YYYY-MM-DD",
				);

				payloadNegociacaoAtivos.trade_quantity = this.changeToFloatApi(
					payloadNegociacaoAtivos.trade_quantity,
				);

				payloadNegociacaoAtivos.gross_amount = this.changeToFloatApi(
					payloadNegociacaoAtivos.gross_amount,
				);

				await axios.post(urlNegociacaoAtivos, payloadNegociacaoAtivos);

				setTimeout(() => {
					window.location.reload();
				}, 1000);
			} catch (error) {
				console.error(error);
			}
		},

		async postMovimentacaoTesouro(currentTarget) {
			try {
				const payloadMovimentacaoTesouro = {
					reference_date: this.formModalAtivo.reference_date,
					movement_type: "Compra",
					treasury_bonds_quantity: this.formModalAtivo.trade_quantity,
					operation_value: this.formModalAtivo.gross_amount,
				};

				const form = currentTarget.closest("form");

				this.formModalAtivo.product_type_name =
					this.formModalAtivo.product_type_name.value ||
					this.formModalAtivo.product_type_name;
				const productType = document.createElement("input");
				productType.type = "hidden";
				productType.name = "product_type_name";
				productType.value = this.formModalAtivo.product_type_name;

				form.appendChild(productType);

				this.isLoading = true;
				// form.submit();

				payloadMovimentacaoTesouro.ticker_symbol =
					typeof this.formModalAtivo.ticker_symbol === "object" &&
					this.formModalAtivo.ticker_symbol !== null
						? this.formModalAtivo.ticker_symbol.value
						: this.formModalAtivo.ticker_symbol;

				payloadMovimentacaoTesouro.reference_date = date.formatDate(
					payloadMovimentacaoTesouro.reference_date,
					"YYYY-MM-DD",
				);

				payloadMovimentacaoTesouro.treasury_bonds_quantity =
					this.changeToFloatApi(
						payloadMovimentacaoTesouro.treasury_bonds_quantity,
					);

				payloadMovimentacaoTesouro.operation_value = this.changeToFloatApi(
					payloadMovimentacaoTesouro.operation_value,
				);

				await axios.post(urlMovimentacaoTesouro, payloadMovimentacaoTesouro);

				setTimeout(() => {
					window.location.reload();
				}, 2000);
			} catch (error) {
				console.error(error);
			}
		},

		onCloseModal() {
			this.clearStates();
		},

		onCancelModal() {
			document.querySelector(".close-modal-btn").click();
			this.clearStates();
		},

		clearStates() {
			this.hasValueInSearch = false;
			this.selectsHasFilled = false;
			this.modalValueIsValid = true;
			this.showError = false;
			this.errorMessage = "";
			this.formModalAtivo = {
				ticker_symbol: "",
				side: "Compra",
				reference_date: "",
				trade_quantity: "",
				gross_amount: "",
				product_type_name: "",
			};
		},

		applyMonetaryMask() {
			setTimeout(() => {
				$(".mask-money-fix").maskMoney({
					thousands: ".",
					decimal: ",",
				});
			}, 500);
			setTimeout(() => {
				$(".mask-money-int").maskMoney({
					thousands: ".",
					decimal: ",",
					precision: 5,
				});
			}, 500);
		},
	},

	delimiters: ["{*", "*}"], //delimitadores pra n conflitar com o django
};
